module.exports = __webpack_public_path__ + "static/hero5-a2e65ff96226d812a64ec5137c2b0150.webp";